'use client';

import { OrderHistory } from 'components/ui/organisms';
import { useOrders } from 'frontastic/hooks';

export const OrderHistoryTastic = () => {
  const ordersResponse = useOrders();

  return <OrderHistory {...ordersResponse} />;
};
